export interface ModuleTenant {
  id: string;
  name: string;
  translation_key: string;
  available_offline: boolean;
  menu_index?: number;
}
